import * as React from 'react';
import { Box, Heading } from '@chakra-ui/react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faFileCircleCheck, faFileCircleQuestion } from '@fortawesome/pro-regular-svg-icons';

interface IProps {
  id?: string;
  title?: React.ReactNode;
  children?: React.ReactNode;
  isSatisfied?: boolean;
}

const RequirementsRemedy = (props: IProps) => {
  const { id, title, children, isSatisfied } = props;

  const getTitle = () => {
    if (isSatisfied) {
      return 'Next steps';
    } else if (title) {
      return title;
    } else {
      return 'What you need to do';
    }
  };

  return (
    <Box data-selector={id} my={10}>
      <Heading as="h4" fontSize="xl" mb={4}>
        <Box as="span" color={isSatisfied ? 'green.400' : 'cyan.400'} mr={2} key="what-do-I-have-to-do">
          <FontAwesomeIcon icon={isSatisfied ? faFileCircleCheck : faFileCircleQuestion} />
        </Box>

        {getTitle()}
      </Heading>

      <Box key="what-do-I-have-to-do">{children}</Box>
    </Box>
  );
};

export { RequirementsRemedy };
